import { datadogRum } from "@datadog/browser-rum";
export enum PerformanceTransactionName {
  DATA_TREE_EVALUATION = "DATA_TREE_EVALUATION",
  EXECUTE_ACTION = "EXECUTE_ACTION",
  SAVE_PAGE_API = "SAVE_PAGE_API",
  USER_ME_API = "USER_ME_API",
  EXTRACT_BINDINGS_FROM_API = "EXTRACT_BINDINGS_FROM_API",
  RENAME_WIDGETS = "RENAME_WIDGETS",
  LOAD_AUTH0 = "LOAD_AUTH0",
  INITIALIZE_APP_SAGA = "INITIALIZE_APP_SAGA",
  FIRST_EVALUATION_ON_LOAD = "FIRST_EVALUATION_ON_LOAD",
}

export enum PerformanceName {
  API_RESPONSE_RECEIVED = "API_RESPONSE_RECEIVED",
  AI_ASSISTANT_OPENED = "AI_ASSISTANT_OPENED",
  AI_RESPONSE_GENERATED = "AI_RESPONSE_GENERATED",
  AI_RESPONSE_USED = "AI_RESPONSE_USED",
}

interface PerfLog {
  skipLog?: boolean;
  eventName: string;
  startTimestamp?: number;
  endTimestamp?: number;
}

class PerformanceTracker {
  private static perfAsyncMap: Map<string, PerfLog> = new Map();

  static track(
    eventName: PerformanceName,
    context: Record<string, number | string> | undefined,
  ) {
    datadogRum.addAction(eventName, context);
  }

  static startAsyncTracking = (
    eventName: PerformanceTransactionName,
    data?: any,
    uniqueId?: string,
    skipLog = false,
  ) => {
    PerformanceTracker.perfAsyncMap.set(uniqueId ? uniqueId : eventName, {
      startTimestamp: performance.now() / 1000,
      eventName: eventName,
      skipLog: skipLog,
    });

    datadogRum.addAction("START_" + eventName, {
      uniqueId,
      data,
    });
  };

  static stopAsyncTracking(
    eventName: PerformanceTransactionName,
    data?: any,
    uniqueId?: string,
  ) {
    const perfLog = PerformanceTracker.perfAsyncMap.get(
      uniqueId ? uniqueId : eventName,
    );
    if (perfLog) {
      const endTimestamp = performance.now() / 1000;
      const startTimestamp = perfLog.startTimestamp ?? endTimestamp;
      if (!perfLog?.skipLog) {
        PerformanceTracker.printDuration(
          perfLog.eventName,
          0,
          startTimestamp,
          endTimestamp,
          true,
        );
        const duration = (endTimestamp - startTimestamp) * 1000;

        datadogRum.addAction(perfLog.eventName, {
          uniqueId,
          duration,
          data,
        });
      }
    }
  }

  static generateSpaces(num: number) {
    let str = "";
    for (let i = 0; i < num; i++) {
      str += "\t";
    }
    return str;
  }

  static printDuration(
    eventName: string,
    level: number,
    startTime: number,
    endTime?: number,
    isAsync?: boolean,
  ) {
    const duration = ((endTime || 0) - startTime) * 1000;
    const spaces = PerformanceTracker.generateSpaces(level);
    console.debug(
      spaces +
        "Transaction " +
        eventName +
        (isAsync ? " (async) " : " ") +
        "finished in " +
        duration.toFixed(0) +
        "ms",
    );
  }
}

export default PerformanceTracker;
